import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAil30aJ8pPD2EkSXAseNrumWYMEID4nvw",
  authDomain: "firechat-5ffd3.firebaseapp.com",
  projectId: "firechat-5ffd3",
  storageBucket: "firechat-5ffd3.appspot.com",
  messagingSenderId: "597629402720",
  appId: "1:597629402720:web:5f13f95fad91c3fe42cd05",
  measurementId: "G-P6KD14BK2W",
});

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };
